/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Layout from "../../components/Layout/layout";
import SpeakersCard from "../../components/SpeakersCard/SpeakersCard";
import speaker1 from "../../assets/themeSpeakersImages/speaker1.jpg";
import speaker3 from "../../assets/themeSpeakersImages/speaker3.jpg";
import speaker4 from "../../assets/themeSpeakersImages/speaker4.jpg";
import speaker5 from "../../assets/themeSpeakersImages/speaker5.jpeg";
import speaker6 from "../../assets/themeSpeakersImages/speaker6.jpeg";
import speaker7 from "../../assets/themeSpeakersImages/speaker7.jpg";
import speaker8 from "../../assets/themeSpeakersImages/speaker8.jpeg";
import speaker9 from "../../assets/themeSpeakersImages/speaker9.jpeg";
import speaker10 from "../../assets/themeSpeakersImages/speaker10.png";
import speaker11 from "../../assets/themeSpeakersImages/speaker11.jpeg";
import speaker12 from "../../assets/themeSpeakersImages/speaker12.png";
import speaker13 from "../../assets/themeSpeakersImages/speaker13.jpeg";
import speaker14 from "../../assets/themeSpeakersImages/speaker14.jpg";
import speaker15 from "../../assets/themeSpeakersImages/speaker15.jpg";
import speaker16 from "../../assets/themeSpeakersImages/speaker16.png";
import speaker17 from "../../assets/themeSpeakersImages/speaker17.jpg";
import speaker18 from "../../assets/themeSpeakersImages/speaker18.jpg";
import speaker19 from "../../assets/themeSpeakersImages/speaker19.jpg";
import speaker20 from "../../assets/themeSpeakersImages/speaker20.jpeg";
import speaker21 from "../../assets/themeSpeakersImages/speaker21.jpg";
import speaker22 from "../../assets/themeSpeakersImages/speaker22.jpeg";
import speaker23 from "../../assets/themeSpeakersImages/speaker23.png";
import speaker24 from "../../assets/themeSpeakersImages/speaker24.jpg";
import speaker25 from "../../assets/themeSpeakersImages/speaker25.png";
import speaker26 from "../../assets/themeSpeakersImages/speaker26.jpg";
import speaker27 from "../../assets/themeSpeakersImages/speaker27.jpg";
import speaker28 from "../../assets/themeSpeakersImages/speaker28.jpg";
import speaker29 from "../../assets/themeSpeakersImages/speaker29.jpg";
import speaker30 from "../../assets/themeSpeakersImages/speaker30.jpeg";
import speaker31 from "../../assets/themeSpeakersImages/speaker31.png";
import speaker32 from "../../assets/themeSpeakersImages/speaker32.jpeg";
import speaker33 from "../../assets/themeSpeakersImages/speaker33.jpeg";
import speaker34 from "../../assets/themeSpeakersImages/SumitKumar.jpeg";
import speaker35 from "../../assets/themeSpeakersImages/speaker35.jpg";
import speaker36 from "../../assets/themeSpeakersImages/speaker36.png";
import speaker37 from "../../assets/themeSpeakersImages/speaker37.jpeg";
import speaker39 from "../../assets/themeSpeakersImages/speaker39.jpeg";
import speaker40 from "../../assets/themeSpeakersImages/speaker40.jpg";
import speaker41 from "../../assets/themeSpeakersImages/speaker41.jpg";
import speaker42 from "../../assets/themeSpeakersImages/speaker42.jpg";
import speaker43 from "../../assets/themeSpeakersImages/speaker43.png";
import speaker44 from "../../assets/themeSpeakersImages/speaker44.webp";
import speaker45 from "../../assets/themeSpeakersImages/speaker45.jpeg";
import speaker46 from "../../assets/themeSpeakersImages/speaker46.jpg";
import speaker47 from "../../assets/themeSpeakersImages/speaker47.jpg";

const PanelSpeaker = () => {
  const speakers = [
    // {
    //   name: "Dr. Krishna Murali A.",
    //   place: "IIT TIRUPATI",
    //   title: "",
    //   img: speaker1,
    //   link: "https://old.iittp.ac.in/dr-a-murali-krishna",
    // },
    // {
    //   name: "Mr. Bhowmick Alok",
    //   place: "B&S Engineering Consultants Pvt. Ltd",
    //   title: "",
    //   img: "",
    //   link: "https://structurae.net/en/literature/authors/bhowmick-alok-28474",
    // },
    // {
    //   name: "Prof. Prashant Amit",
    //   place: "IIT GANDHINAGAR",
    //   title: "",
    //   img: speaker3,
    //   link: "https://iitgn.ac.in/faculty/civil/fac-amit",
    // },
    {
      name: "Dr. Pain Anindya",
      place: "Central Building Research Institute (CBRI) Roorkee",
      title:
        "Probabilistic stability analysis of reinforced soil retaining structures under static and seismic conditions",
      img: speaker4,
      link: "https://cbri.res.in/scientific-profiles/group-iv/principal-scientist/anindya-pain/",
    },
    {
      name: "Prof. Dey Arindam",
      place: "IIT GUWAHATI",
      title: "Seismic Response of Geosynthetic Reinforced Earth Structures",
      img: speaker5,
      link: "https://www.iitg.ac.in/arindam.dey/homepage/index.html",
    },
    {
      name: "Prof. Juneja Ashish",
      place: "IIT BOMBAY",
      title:
        "Studies on monotonic and undrained cyclic response of bio-cemented sand considering the morphology of its bio-precipitate",
      img: speaker6,
      link: "https://www.civil.iitb.ac.in/faculty/details/prof-ashish-juneja",
    },
    {
      name: "Prof. Manna Bappaditya",
      place: "IIT DELHI",
      title: "",
      img: speaker7,
      link: "https://web.iitd.ac.in/~bmanna/",
    },
    // {
    //   name: "Dr. Kumar Devender",
    //   place: "NGRI",
    //   title: "",
    //   img: speaker8,
    //   link: "https://www.researchgate.net/profile/Devender-Kumar-9",
    // },
    // {
    //   name: "Dr. Ramana G.V.",
    //   place: "IIT DELHI",
    //   title: "",
    //   img: speaker9,
    //   link: "https://scholar.google.com.sg/citations?user=c_jMH2MAAAAJ&hl=en",
    // },
    // {
    //   name: "Sahoo Prasad Jagdish",
    //   place: "IIT KANPUR",
    //   title: "",
    //   img: speaker10,
    //   link: "https://iitk.ac.in/new/jagdish-prasad-sahoo",
    // },
    // {
    //   name: "Sylaja Jayan Vinod",
    //   place: "University of Wollongong",
    //   title: "-",
    //   img: speaker11,
    //   link: "https://scholars.uow.edu.au/vinod-jayan-sylaja",
    // },
    // {
    //   name: "Prof. Deb Kousik",
    //   place: "IIT KHARAGPUR",
    //   title: "-",
    //   img: speaker12,
    //   link: "https://www.iitkgp.ac.in/department/CE/faculty/ce-kousik",
    // },
    // {
    //   name: "Dr. Satyam Neelima",
    //   place: "IIT INDORE",
    //   title: "",
    //   img: speaker13,
    //   link: "http://people.iiti.ac.in/~neelima.satyam/",
    // },
    // {
    //   name: "Dr. Mishra O.P.",
    //   place: "National Centre of Seismology",
    //   title: "Seismic Risk Resilient structures and Seismic Microzonation",
    //   img: speaker14,
    //   link: "https://scholar.google.com.vn/citations?user=1wBSBrQAAAAJ&hl=vi",
    // },
    {
      name: "Prof. Anbazhagan P.",
      place: "IISC BANGLORE",
      title:
        "Next Generation Intensity Prediction Equations for Himalaya RegionsNext-Generation Earthquake Intensity and Magnitude Prediction Equations for Himalayan Region",
      img: speaker15,
      link: "http://civil.iisc.ac.in/~anbazhagan/",
    },
    // {
    //   name: "Dr. Choudhury Pallabee",
    //   place: "ISR",
    //   title: "WILL BE UPDATED SOON",
    //   img: speaker16,
    //   link: "https://isr.gujarat.gov.in/pallabee-choudhury",
    // },
    // {
    //   name: "Prof. Raychowdhury Prishati",
    //   place: "IIT KANPUR",
    //   title: "WILL BE UPDATED SOON",
    //   img: speaker17,
    //   link: "https://www.iitk.ac.in/new/prishati-raychowdhury",
    // },
    {
      name: "Prof. Ghosh Priyanka",
      place: "IIT KANPUR",
      title: "Vibration Mitigation Behavior of Bamboo-filled Barriers ",
      img: speaker18,
      link: "https://www.iitk.ac.in/new/priyanka-ghosh",
    },
    {
      name: "Prof. Jakka Sankar Ravi",
      place: "IIT ROORKEE",
      title:
        "Skirted Footings in Geotechnical Engineering: Evolution,Applications and Innovations",
      img: speaker19,
      link: "https://www.iitr.ac.in/~EQ/jakkafeq",
    },
    {
      name: "Prof. Nimbalkar Sanjay",
      place: "University of Technology Sydney (UTS)",
      title:
        "Innovative Approaches for Addressing Challenges in High-Speed Railway Geotechnics",
      img: speaker20,
      link: "https://profiles.uts.edu.au/sanjay.nimbalkar",
    },
    // {
    //   name: "Prof. Kolathayar Sreevalsa",
    //   place: "NIT Surathkal",
    //   title: "",
    //   img: speaker21,
    //   link: "https://civil.nitk.ac.in/professor/sreevalsa-kolathayar",
    // },
    // {
    //   name: "Prof. Bhattacharya Subhamoy",
    //   place: "University of Surrey",
    //   title: "Seismic design of offshore wind farms",
    //   img: speaker22,
    //   link: "https://www.researchgate.net/profile/Subhamoy-Bhattacharya",
    // },
    // {
    //   name: "Dr. Lopez-Querol Susana",
    //   place: "University College London",
    //   title: "",
    //   img: speaker23,
    //   link: "https://www.ucl.ac.uk/civil-environmental-geomatic-engineering/people/dr-susana-lopez-querol",
    // },
    {
      name: "Prof. Banerjee Subhadeep",
      place: "IIT MADRAS",
      title:
        "Study on a Novel Geotechnical Seismic Isolation system using Geogrid Reinforced Sand & Shredded Rubber Mixture",
      img: speaker24,
      link: "https://home.iitm.ac.in/subhadeep/index.htm",
    },
    {
      name: "Prof. Haldar Sumanta",
      place: "IIT Bhubaneswar",
      title: "WILL BE UPDATED SOON",
      img: speaker25,
      link: "https://www.iitbbs.ac.in/index.php/prof-sumanta-haldar/",
    },
    {
      name: "Dr. Veeraraghavan Swetha",
      place: "IISC BANGLORE",
      title: "Seismic safety Assessment of Critical Infrastructure(TENTATIVE)",
      img: speaker26,
      link: "http://civil.iisc.ac.in/~swethav/",
    },
    // {
    //   name: "Prof. Chakraborty Tanusree",
    //   place: "IIT DELHI",
    //   title: "",
    //   img: speaker27,
    //   link: "https://web.iitd.ac.in/~tanusree/",
    // },
    // {
    //   name: "Prof. Sawant Vishwas",
    //   place: "IIT ROORKEE",
    //   title: "",
    //   img: speaker28,
    //   link: "https://civil.iitr.ac.in/CE?Uid=sawantfce",
    // },
    // {
    //   name: "Prof. Thakur Vikash",
    //   place: "NTNU",
    //   title: "",
    //   img: speaker29,
    //   link: "https://www.ntnu.edu/employees/vikas.thakur",
    // },
    // {
    //   name: "Prof. Samui Pijush",
    //   place: "NIT PATNA",
    //   title: "Data-Driven models in Geotechnical Earthquake Engineering",
    //   img: speaker30,
    //   link: "https://nitp.irins.org/profile/100911",
    // },
    {
      name: "Prof. Mohanty K. William",
      place: "IIT KHARAGPUR",
      title:
        "Frequent occurrences of moderate earthquakes from the Shillong Plateau and adjoining region of the North-East, India: Implication of future potential of seismic source zone of bigger earthquakes?",
      img: speaker31,
      link: "https://www.iitkgp.ac.in/department/GG/faculty/gg-wkmohanty",
    },
    // {
    //   name: "Dr. Boominathan A.",
    //   place: "IIT MADRAS",
    //   title: "",
    //   img: speaker32,
    //   link: "https://civil.iitm.ac.in/faculty/boomi/",
    // },
    // {
    //   name: "Dr. Chopra Sumer",
    //   place: "ISR",
    //   title: "",
    //   img: speaker33,
    //   link: "https://www.researchgate.net/profile/Sumer-Chopra",
    // },
    {
      name: "Dr.Sinha Kumar Sumit",
      place: "IIT DELHI",
      title:
        "Performance of Axially Loaded Piles Subject to Liquefaction Induced Downdrag",
      img: speaker34,
      link: "https://sumeetksinha.com/biography/",
    },
    // {
    //   name: "Dr. Kanungo D.P.",
    //   place: "CBRI",
    //   title: "",
    //   img: speaker35,
    //   link: "https://cbri.res.in/scientific-profiles/group-iv/chief-scientist/d-p-kanungo/",
    // },
    // {
    //   name: "Gupta Vikram",
    //   place: "WIHG",
    //   title: "",
    //   img: speaker36,
    //   link: "https://www.researchgate.net/profile/Vikram-Gupta-9",
    // },
    {
      name: "Prof. Stuedlein Armin W.",
      place: "Oregon State University, USA",
      title:
        "Comparison of In-Situ and Laboratory Test-based Soil Liquefaction and Cyclic Softening Responses",
      img: speaker37,
      link: "https://engineering.oregonstate.edu/people/armin-stuedlein-pe-wa",
    },
    // {
    //   name: "Dr. Sil Arjun",
    //   place: "NIT SILCHAR",
    //   title:
    //     "Development of Frequency-Domain Hazard Spectra Using PSHA framework for Enhanced Earthquake Resilience",
    //   img: speaker39,
    //   link: "http://ce.nits.ac.in/arjun/",
    // },
    // {
    //   name: "Prof. Emani Kumar Pavan",
    //   place: "Siddaganga Institute of Technology",
    //   title: "",
    //   img: speaker40,
    //   link: "https://sit.irins.org/profile/167299",
    // },
    {
      name: "Dr. James Naveen",
      place: "IIT Ropar",
      title: "Liquefaction Mitigation Using Natural Rubber Latex Treatment",
      img: speaker41,
      link: "https://www.iitrpr.ac.in/cse/naveenjames",
    },
    {
      name: "Prof. Chatterjee Kaustav",
      place: "IIT ROORKEE",
      title: "WILL BE UPDATED SOON",
      img: speaker42,
      link: "https://civil.iitr.ac.in/CE?Uid=kchatfce",
    },
    // {
    //   name: "Mr. Bhowmick Alok",
    //   place: "B&S Engineering Consultants Pvt. Ltd",
    //   title: "Evolution of Seismic Design Codes in India",
    //   img: speaker43,
    //   link: "https://structurae.net/en/literature/authors/bhowmick-alok-28474",
    // },
    // {
    //   name: "Dr. Dammala Kumar Pradeep",
    //   place: "IIT JODHPUR",
    //   title: "WILL BE UPDATED SOON",
    //   img: speaker44,
    //   link: "https://pradeepkumardammal.wixsite.com/iitj",
    // },
    // {
    //   name: " Dr. Ghosh Barnali",
    //   place: "Mott MacDonald Group",
    //   title:
    //     "Creating Added Value through Adaptive Design & Climate Change - A Seismic Perspective",
    //   img: speaker45,
    //   link: "https://www.researchgate.net/profile/Barnali-Ghosh-2",
    // },
    {
      name: " Dr. Tiwari Rohit",
      place: "University of New South Wales, Sydney",
      title:
        "Physical Modelling, Shaking Table Experiments, and Numerical Simulations of Seismic Actions on Retaining Walls with Different Support Conditions",
      img: speaker46,
      link: "https://www.unsw.edu.au/staff/rohit-tiwari",
    },
    {
      name: " Dr. Jana Amalesh",
      place: "Montana State University ",
      title:
        "Cyclic Threshold Shear Strain to Trigger LiqueEffect of Repeated Cyclic Straining on Dynamic Properties of Silts from Elemental and In-situ Testsfaction in Gravelly Soil",
      img: speaker47,
      link: "https://www.montana.edu/ce/directory/2538546/amalesh-jana",
    },
  ];

  const stripPrefix = (name) => {
    return name.replace(/^(Prof\.|Dr\.|Mr\.|Mrs\.|Ms\.\s)/i, "").trim();
  };

  const sortedMembers = speakers.sort((a, b) =>
    stripPrefix(a.name).localeCompare(stripPrefix(b.name))
  );

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10 ">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 bg-white z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] pb-4">
            THEME SPEAKERS
          </div>
          <div className="flex flex-wrap justify-between">
            {sortedMembers.map((speaker, index) => (
              <a key={index} href={speaker.link}>
                <SpeakersCard
                  name1={speaker.name}
                  place1={speaker.place}
                  note1={speaker.title}
                  speaker1={speaker.img}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PanelSpeaker;
